import { withStyles } from "@mui/styles";

import SingleLineTextInput from "../../components/singleLineTextInput/SingleLineTextInput";
import ErrorMessage from "../../components/errorMessage/ErrorMessage";

const isInvalidPassword = (name) => !name;

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
});

function EditPasswordForm({
  classes,
  payload,
  storePayload,
  errorMessage,
  submitAttempted,
}) {
  return (
    <div className={classes.section}>
      <SingleLineTextInput
        label="OLD PASSWORD"
        value={payload.oldPassword}
        onChange={(value) => storePayload({ ...payload, oldPassword: value })}
        showInvalidInput={
          submitAttempted && isInvalidPassword(payload.oldPassword)
        }
        required={true}
        type="password"
      />

      <SingleLineTextInput
        label="NEW PASSWORD"
        value={payload.newPassword}
        onChange={(value) => storePayload({ ...payload, newPassword: value })}
        showInvalidInput={
          submitAttempted && isInvalidPassword(payload.newPassword)
        }
        required={true}
        type="password"
      />

      <SingleLineTextInput
        label="REPEAT PASSWORD"
        value={payload.repeatPassword}
        onChange={(value) =>
          storePayload({ ...payload, repeatPassword: value })
        }
        showInvalidInput={
          submitAttempted && isInvalidPassword(payload.repeatPassword)
        }
        required={true}
        type="password"
      />

      {errorMessage && <ErrorMessage message={errorMessage} />}
    </div>
  );
}

export default withStyles(styles)(EditPasswordForm);
